import React from 'react';
import PropTypes from 'prop-types';
import ServiceAddPres from '../../ServiceInit/presentational/ServiceAddPres';
import intl from 'react-intl-universal';

export const ConsentPage = React.forwardRef(
  ({ pageHTML, togleConsent, accepted, acceptable }, { consentContentRef, consentInnerContentRef }) => {
    function getpageHTML(pageHTML) {
      return { __html: pageHTML };
    }

    return (
      <React.Fragment>
        <div className="consent-page">
          <div className="consent-inner-content" ref={consentInnerContentRef}>
            <div className="consent-content" dangerouslySetInnerHTML={getpageHTML(pageHTML)} ref={consentContentRef} />
          </div>
          <div className="consent-accept-bar">
            <label className="checkbox">
              <input type="checkbox" name="corporateClient" disabled={!acceptable} checked={accepted} onChange={togleConsent.bind(this)} />
              {intl.get('consent.accept')}
            </label>
          </div>
        </div>
      </React.Fragment>
    );
  },
);

ServiceAddPres.propTypes = {
  pageHTML: PropTypes.string,
  togleConsent: PropTypes.func,
  accepted: PropTypes.bool,
};

export default ConsentPage;
